module.exports = "- Announce the number of search results found.\n"